<template>
  <div>
    <div class="text-center">
      <img
        src="@/assets/images/logo_egis.png"
        alt="EGIS"
        style="margin: auto"
        class="logo-egis d-none d-sm-block d-md-block d-lg-block"
      />
    </div>
    <div v-if="error !== ''" class="text-center mt-5">{{ error }}</div>
    <div v-else>
      <div class="text-center mb-5 mt-3">
        <h4>Recuperação de Senha</h4>
        <h5>Você solicitou a recuperação da senha através de um link. Por favor digite uma nova senha abaixo:</h5>
      </div>
      <b-row>
        <b-col lg="4" offset="4">
          <b-form-group id="fieldset-3" label="Nova Senha" label-for="cp_new">
            <b-form-input id="cp_new" type="password" v-model="newPassword" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" offset="4">
          <b-form-group id="fieldset-4" label="Confirmação" label-for="cp_confirm">
            <b-form-input id="cp_confirm" type="password" v-model="confirmation" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" offset="4">
          <b-button @click="doChangePwd" variant="primary" block>Alterar</b-button>
        </b-col>
      </b-row>
    </div>
    <b-button @click="$router.push({name: 'login'})">Voltar</b-button>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";

export default {
  name: "Recovery",
  data: function() {
    return {
      newPassword: "",
      confirmation: "",
      error: ""
    };
  },
  methods:{
    doChangePwd(){
      if(this.newPassword !== this.confirmation){
        this.$toasted.info("Nova senha não confere!", {duration: 4000, keepOnHover: true, className: 'v-toasted-warning'});
        return;
      }

      axios.post(`${baseApiUrl}/usuarios/changepwd3`, {token: this.$route.query.token, senha: this.newPassword})
        .then(() => {
          this.$toasted.info("Senha alterada com sucesso!", {duration: 4000, keepOnHover: true});
          this.$router.push({path: '/login'}).catch(() => {});
        })
        .catch(ex => showError(ex))
    }
  },
  mounted() {
    this.error = "";
    axios
      .get(`${baseApiUrl}/recovery-token/${this.$route.query.token}`)
      .catch(() => {
        this.error = "Token informado é inválido!";
      });
  }
};
</script>

<style>
</style>